import { createContext, useContext, useState, ReactNode, useCallback } from "react";

interface NavigationContextType {
  isNavigating: boolean;
  targetLabel: string;
  startNavigation: (label: string) => void;
  endNavigation: () => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export const NavigationProvider = ({ children }: { children: ReactNode }) => {
  const [isNavigating, setIsNavigating] = useState(false);
  const [targetLabel, setTargetLabel] = useState("");

  const startNavigation = useCallback((label: string) => {
    setTargetLabel(label);
    setIsNavigating(true);
  }, []);

  const endNavigation = useCallback(() => {
    setIsNavigating(false);
    setTargetLabel("");
  }, []);

  return (
    <NavigationContext.Provider value={{ isNavigating, targetLabel, startNavigation, endNavigation }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error("useNavigation must be used within a NavigationProvider");
  }
  return context;
};
